import React from "react";
import {
  CircularProgress,
  LinearProgress,
  Typography,
  Stack,
  Box,
} from "@mui/material";

const LoadingWidget = ({
  label = "Loading...",
  type = "circular",
  thickness = 4,
  color = "primary",
  value,
  labelPosition = "bottom",
  size = 40,
  width = "100%",
}) => {
  const progressProps = {
    thickness,
    color,
    ...(value !== undefined && { value }),
  };

  return (
    <Stack
      direction={labelPosition === "right" ? "row" : "column"}
      alignItems="center"
      spacing={2}
      width={type === "linear" ? width : "auto"}
    >
      {type === "circular" ? (
        <CircularProgress {...progressProps} size={size} />
      ) : (
        <Box width={width}>
          <LinearProgress
            {...progressProps}
            variant={value !== undefined ? "determinate" : "indeterminate"}
          />
        </Box>
      )}

      <Typography variant="body1" color="text.secondary">
        {label}
      </Typography>
    </Stack>
  );
};

export default LoadingWidget;
